<template>
  <div>
    <div class="sidebar-heading d-flex align-center justify-start mb-5">
      <v-icon class="mr-2" color="primary" :size="defaultIconSize">
        $page
      </v-icon>
      <h3 class="regular-action-title sidebar-heading mb-0">
        {{ $t("chapter.infoPopup.infoPopupContents") }}
      </h3>
    </div>
    <v-expansion-panels
      flat
      class="chapter-details-expansion-panels"
      multiple
      :value="[0, 1]"
    >
      <v-expansion-panel  class="mb-3 pa-0">
        <v-expansion-panel-header
          expand-icon="$chevronDown"
          class="d-flex align-center justify-start px-3 py-2"
        >
          <div class="ml-2">{{ $t("chapter.infoPopup.popupSettings") }}</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content v-if="editor"  class="pa-2 pb-5">
          <InfoMediaUpload :editor="editor" class="mb-4" />
          <label for="info-text-input">
            {{ $t("chapter.infoPopup.textBlock") }}
          </label>
          <v-textarea
            id="info-text-input"
            v-model="info"
            class="story-city-textarea"
            solo
            outlined
            flat
            :counter="maxLengthCharacters"
            @input="updateInfo"
            color="accentElement"
          />
          <v-btn
            small
            color="error"
            @click="removePopup"
            depressed
          >
            <v-icon class="mr-2">$trash</v-icon>
            {{ $t("chapter.infoPopup.remove") }}
          </v-btn>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import InfoMediaUpload from "./InfoMediaUpload";
import debounce from "@/helpers/debounce";
import { GRADIENTS, DEFAULT_ICON_SIZE } from "@/const";

const MAX_LENGTH_CHARACTERS = 600;
export default {
  props: {
    editor: Object,
    infoValue: String,
  },
  components: {
    InfoMediaUpload,
  },
  data() {
    return {
      info: this.infoValue ? this.infoValue : "",
    };
  },
  methods: {
    updateInfo: debounce(async function () {
      this.editor
        .chain()
        .setInfoValue(this.info.slice(0, MAX_LENGTH_CHARACTERS))
        .run();
    }, 500),
    removePopup() {
      this.editor.chain().focus().unsetInfo().run();
    },
  },
  watch: {
    infoValue(newValue) {
      if (this.info != newValue) {
        this.info = newValue;
      }
    },
  },
  computed: {
    maxLengthCharacters() {
      return MAX_LENGTH_CHARACTERS;
    },
    gradients() {
      return GRADIENTS;
    },
    defaultIconSize() {
      return DEFAULT_ICON_SIZE;
    },
  },
};
</script>
